import * as types from '../actions/actionTypes';
import {
  shouldUseMultipleWorkSheets,
  updateDiscountCurrentValues
} from "../bvcomponents/priceWorksheet/discountFunctions";

const initialState = {
  priceWorksheetOpened: false,
  discountsReceived: false,
  discountSections: [],
  customAddedDiscounts: [], // same as discountInterface[], but also {categoryId, uuid}
  financePercentage: "", // %
  allFinanceOptionsPopupVisible: false,
  financeCellsVisible: false, // boolean
  workSheetsCount: 1, // number of different wizard sheets selections (according to dashboard)
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.SET_CUSTOM_ADDED_DISCOUNTS:
    case types.SET_FINANCE_PERCENTAGE:
    case types.SET_ALL_FINANCE_OPTIONS_POPUP_VISIBLE:
    case types.SET_DISCOUNT_FINANCE_CELLS_VISIBLE:
    case types.SET_DISCOUNT_WORKSHEET_COUNT:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.TOGGLE_PRICE_WORKSHEET_OPENED:
      return Object.assign({}, state, {
        priceWorksheetOpened: action.payload.priceWorksheetOpened,
      });
    case types.SET_DISCOUNT_SECTIONS:
      return Object.assign({}, state, {
        ...action.payload,
        discountsReceived: true
      });
    case types.SET_ACTIVE_QUOTE_INDEX:
      if (shouldUseMultipleWorkSheets(state.workSheetsCount)) {
        return Object.assign({}, state, {
          discountSections: state.discountSections.map(discountSection => {
            discountSection.discounts = discountSection.discounts.map(discount => {
              return updateDiscountCurrentValues(discount, action.payload.activeQuoteIndex)
            })
            return discountSection
          })
        });
      }
  }

  return state;
}
